<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang].title : ''" :type="'gray'" >
        <template v-slot:body>
            <div class="w-full flex mb-4 
                xl:grid lg:grid md:grid
                gap-5 xl:gap-0 lg:gap-0 md:gap-0
                flex-column xl:flex-row lg:flex-row md:flex-row">
                <div class="flex flex-column
                    col-12 xl:col-8 lg:col-8 md:col-6
                    gap-5 xl:gap-7 lg:gap-6
                    p-0 xl:pr-3 lg:pr-3 md:pr-3">

                    <div class="w-full flex flex-column">
                        <div class="w-full flex flex-row mb-3 justify-content-center align-items-center">
                            <div class="flex flex-1">
                                <span class="font-medium text-xl text-700 h-2rem">{{ content[lang].faqTitle }}</span>
                            </div>
                            <div class="flex">
                                <Button :label="content[lang].faqBtn" @click="goToFaq" class="text-xs surface-0" icon="pi pi-angle-right" iconPos="right" size="small" rounded severity="secondary" />
                            </div>
                        </div>
                        <div class="w-full flex">
                            <FaqShortList v-if="tabs" :tabs="tabs" :count="3" />
                        </div>
                    </div>

                    <div v-if="isTgApp || isPWA" class="w-full flex flex-column max-w-30rem">
                        <div class="w-full flex flex-row mb-3 justify-content-center align-items-center">
                            <div class="flex flex-1">
                                <span class="font-medium text-xl text-700 h-2rem">{{ content[lang].chat }}</span>
                            </div>
                        </div>
                        <div class="w-full flex">
                            <Button v-if="isTgApp" :label="content[lang].chatBtnBot" @click="goToTgChat" class="w-full border-round-xl" icon="pi pi-telegram" iconPos="right" size="large"/>
                            <Button v-else :label="content[lang].chatBtn" @click="showChat=true" class="w-full border-round-xl" icon="pi pi-comments" iconPos="right" size="large"/>
                        </div>
                    </div>
                </div>
                    
                <div class="flex flex-column max-w-30rem 
                    col-12 xl:col-4 lg:col-4 md:col-6
                    gap-4 xl:gap-6 lg:gap-5
                    px-0 xl:pl-3 lg:pl-3 md:pl-3">

                    <!--SocLinks-->
                    <div class="w-full flex flex-column">
                        <div class="w-full flex flex-row justify-content-center align-items-center">
                            <div class="flex flex-1">
                                <span class="font-medium text-xl text-700 h-2rem mb-1">{{ content[lang].contacts }}</span>
                            </div>
                        </div>
                        <div class="w-full flex">
                            <SocLinks />
                        </div>
                    </div>

                    <!--SocLinks-->
                    <div class="w-full flex flex-column">
                        <div class="w-full flex flex-row justify-content-center align-items-center">
                            <div class="flex flex-1">
                                <span class="font-medium text-xl text-700 h-2rem mb-1">{{ content[lang].about }}</span>
                            </div>
                        </div>
                        <div class="w-full flex">
                            <div class="w-full flex flex-column gap-3
                                xl:flex-row lg:flex-row md:flex-row
                                mb-0 xl:mb-6 lg:mb-6 md:mb-5">
                                <MobMenu :items=[]>
                                    <template v-slot:body>
                                        <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="goTo('/about/')">
                                            <div class="flex mr-3 align-items-center">
                                                <Avatar class="text-600" size="small" icon="pi pi-trophy" shape="circle"/>
                                            </div>
                                            <div class="flex flex-1 justify-content-left align-items-center">
                                                <span class="text-600">{{ content[lang].company }}</span>
                                            </div>
                                            <div class="flex justify-content-right align-items-center">
                                                <i class="text-blue-500 ml-2 pi pi-arrow-right" />
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="goTo('/reviews/')">
                                            <div class="flex mr-3 align-items-center">
                                                <Avatar class="text-600" size="small" icon="pi pi-star" shape="circle"/>
                                            </div>
                                            <div class="flex flex-1 justify-content-left align-items-center">
                                                <span class="text-600">{{ content[lang].reviews }}</span>
                                            </div>
                                            <div class="flex justify-content-right align-items-center">
                                                <i class="text-blue-500 ml-2 pi pi-arrow-right" />
                                            </div>
                                        </div>
                                    </template> 
                                </MobMenu>
                            </div>
                        </div>
                    </div>

                    <!--Regulations-->
                    <div class="w-full flex flex-column">
                        <div class="w-full flex flex-row justify-content-center align-items-center">
                            <div class="flex flex-1">
                                <span class="font-medium text-xl text-700 h-2rem mb-1">{{ content[lang].regulation }}</span>
                            </div>
                        </div>
                        <div class="w-full flex">
                            <div class="w-full flex flex-column gap-3
                                xl:flex-row lg:flex-row md:flex-row
                                mb-0 xl:mb-6 lg:mb-6 md:mb-5">
                                <MobMenu :items=[]>
                                    <template v-slot:body>
                                        <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="goTo('/policy/')">
                                            <div class="flex mr-3 align-items-center">
                                                <Avatar class="text-600" size="small" icon="pi pi-user" shape="circle"/>
                                            </div>
                                            <div class="flex flex-1 justify-content-left align-items-center">
                                                <span class="text-600">{{ content[lang].politic }}</span>
                                            </div>
                                            <div class="flex justify-content-right align-items-center">
                                                <i class="text-blue-500 ml-2 pi pi-arrow-right" />
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="goTo('/terms/')">
                                            <div class="flex mr-3 align-items-center">
                                                <Avatar class="text-600" size="small" icon="pi pi-file" shape="circle"/>
                                            </div>
                                            <div class="flex flex-1 justify-content-left align-items-center">
                                                <span class="text-600">{{ content[lang].agreement }}</span>
                                            </div>
                                            <div class="flex justify-content-right align-items-center">
                                                <i class="text-blue-500 ml-2 pi pi-arrow-right" />
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="goTo('/aml/')">
                                            <div class="flex mr-3 align-items-center">
                                                <Avatar class="text-600" size="small" icon="pi pi-shield" shape="circle"/>
                                            </div>
                                            <div class="flex flex-1 justify-content-left align-items-center">
                                                <span class="text-600">{{ content[lang].aml }}</span>
                                            </div>
                                            <div class="flex justify-content-right align-items-center">
                                                <i class="text-blue-500 ml-2 pi pi-arrow-right" />
                                            </div>
                                        </div>
                                    </template>
                                </MobMenu>
                            </div>
                        </div>
                    </div>

                </div>
            
            </div>
        </template>
    </Page>

    <Dialog v-model:visible="showChat" header="Чат" blockScroll modal
        style="height: 100%; width: 100%;"
        contentStyle="height: 100%; width: 100%;"
        class="w-full h-full">
        <div class="w-full">
            <Chat />
        </div>
    </Dialog>

</template>

<script>
import Event            from '@/assets/js/Event'
import Helper           from '@/assets/js/Helper.js'
import Page             from '@/components/sides/Page.vue' 
import Chat             from '@/components/widgets/Chat.vue' 
import faq_json         from '@/assets/json/faq.json'
import FaqShortList     from '@/components/widgets/FaqList.vue'
import SocLinks         from '@/components/widgets/SocLinks.vue'
import MobMenu          from '@/components/sides/menu/MobMenu.vue' 
import { mapActions }   from 'vuex'

export default {
    data() {
        return {
            header:{
                en: {title: "Support"} ,
                ru: {title: "Поддержка"} ,
            },
            content: {
                ru: {
                    faqTitle: "FAQ",
                    faqBtn: "Все ответы",

                    chat: "Чат поддержки",
                    chatBtn: "Написать в чат",
                    chatBtnBot: "Написать в чат-бот",

                    contacts: "Контакты",
                    about: "О проекте",
                    regulation: "Документы",
                    company: "О компании",
                    reviews: "Отзывы",
                    politic: "Политика конфиденциальности",
                    agreement: "Пользовательское соглашение",
                    aml: "Политика AML",
                },
                en: {
                    faqTitle: "FAQ",
                    faqBtn: "All answers",

                    chat: "Support chat",
                    chatBtn: "Write to chat",
                    chatBtnBot: "Write to chat-bot",
                    
                    contacts: "Social networks",
                    about: "About project",
                    regulation: "Regulations",
                    company: "About company",
                    reviews: "Reviews",
                    politic: "Privacy policy",
                    agreement: "User agreement",
                    aml: "AML policy",
                }
            },

            tabs: null,
            write_to:{
                en: {content: "For any questions, write to Mr. Freeman via"} ,
                ru: {content: "По любим вопросам пишите Mr. Freeman в"},
            },
            with_chat:{
                en: {content: "chat"} ,
                ru: {content: "чат"},
            },
            with_email:{
                en: {content: "or email"} ,
                ru: {content: "или на email"},
            },
            with_telegram:{
                en: {content: "telegram"} ,
                ru: {content: " в telegram"},
            },
            with_whatsapp:{
                en: {content: "whatsapp"} ,
                ru: {content: " в whatsapp"},
            },

            showChat: false
        }
    },
    components: {
        Page,
        Chat,
        FaqShortList,
        SocLinks,
        MobMenu
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
    methods: {
        goToTgChat(){
            try{
                window.open('https://t.me/pw_origin_bot', '_blank')
            } catch(e){
                console.log(e)
            }
        },
        goToFaq(){
            this.$router.push({ path: '/support/faq/' })
        },
        goTo(path){
            try{
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } catch {}
            try{
                window.Telegram.WebApp.HapticFeedback.impactOccurred('light')
            } catch {}
            this.$router.push({ path: path })
        },
        go_chat(){
            this.event.send('linkChat')
            try{
                SibConversations('openChat', true)
            } catch(e){
                console.log(e)
            }
        },
        go_mail(){
            this.event.send('linkMail')
        },
        go_tele(){
            this.event.send('linkTg')
            try{
                window.open('https://t.me/pw_origin_bot', '_blank')
            } catch(e){
                console.log(e)
            }
        },
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    beforeCreate(){
        this.event = new Event(this) 
        this.helper = new Helper()
    },
    mounted(){
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        if(faq_json){
            if(faq_json.length>3) this.tabs = faq_json.slice(0, 3)
            else this.tabs = faq_json
        }
        // редиректы для моб приложения
        if(this.$route.query.redirect){
            if(this.$route.query.redirect == 'telegram') this.go_tele()
            if(this.$route.query.redirect == 'chat') this.go_chat()
        }

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>